import { useTranslation } from 'react-i18next';
import { BA_COVERAGE } from './baCoverageSpec';
import type { IBaStakeholdersProps } from './IBaStakeholdersProps';

/** Підпис стовпця для виду таблиці сторін (прототип v4: Needs · Use cases · Requirements). */
const COLUMN: Record<string, string> = { 'Stakeholder need': 'needs', 'Use case': 'useCases', Requirement: 'requirements' };

/**
 * «Зацікавлені сторони × аналіз» (прототип v4 bdStake): шапка (Зацікавлена сторона · Потреби · Сценарії використання · Вимоги) і рядок на
 * кожну сторону з трьома моноширинними кнопками-кількостями — відкривають записи виду для сторони.
 */
export function BaStakeholders({ rows, nameOf, onOpen }: IBaStakeholdersProps) {
  const { t } = useTranslation();
  return (
    <div className="ba-stake">
      <div className="ba-sgrid ba-shead">
        <span>{t('modBody.ba.stakeholder')}</span>
        {BA_COVERAGE.stakeKinds.map((kind) => <span key={kind}>{t(`modBody.ba.${COLUMN[kind] ?? 'needs'}`)}</span>)}
      </div>
      {rows.map((row) => (
        <div key={row.value} className="ba-sgrid ba-srow">
          <strong>{nameOf(row.value)}</strong>
          {BA_COVERAGE.stakeKinds.map((kind, i) => (
            <button key={kind} type="button" className="ba-sbtn" onClick={() => onOpen(kind, row.value)}>{String(row.counts[i] ?? 0)}</button>
          ))}
        </div>
      ))}
    </div>
  );
}
